/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.redeemAmazonCatalogueItem.internal

import features.redeemAmazonCatalogueItem.models.RedeemAmazonItemRequest
import features.redeemAmazonCatalogueItem.models.RedeemResponseModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class RedeemAmazonCatalogueItemsRequest : NetworkRequest() {

    suspend fun redeemAmazonCatalogueItem(
        overrideHeaders: Map<String, String>? = null,
        redeemAmazonItemRequest: RedeemAmazonItemRequest
    ): IOResult<RedeemResponseModel> {
        return safeNetworkCall {
            post<RedeemResponseModel, RedeemAmazonItemRequest>(
                endpoint = RedeemAmazonCatalogueItemsEndpoint,
                requestBody = redeemAmazonItemRequest,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
